import { Box, Typography } from '@mui/material';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import roomsImage from 'src/assets/jpg/rooms-image.webp';
import hosRoomsImage from 'src/assets/png/hos-rooms-image.png';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

const { isHosTheme } = getTheme();

// Fills the results area before the user has picked their stay
export const RoomsPromo: FC = () => {
    const { t } = useTranslation();

    return (
        <Box component="section" css={styles.resultsSection}>
            <Box css={styles.promo}>
                {/* Decorative, the overlay text carries the message */}
                <img src={isHosTheme ? hosRoomsImage : roomsImage} alt="" css={styles.promoImage} />

                <Box css={styles.promoContent}>
                    <Box css={styles.promoText}>
                        {isHosTheme ? (
                            <Typography variant="h2" css={styles.promoTitle}>
                                {t('rooms_page_promo_hos_title')}
                            </Typography>
                        ) : (
                            <Fragment>
                                <Typography variant="h2" css={styles.promoTitle}>
                                    {t('rooms_page_promo_title_line_1')}
                                    <br />
                                    {t('rooms_page_promo_title_line_2')}
                                </Typography>
                                <Typography css={styles.promoTagline}>
                                    {t('rooms_page_promo_tagline')}
                                </Typography>
                            </Fragment>
                        )}
                    </Box>

                    {/* One word per line, matching the stacked brand line on the Vita Student site */}
                    <Typography css={styles.promoSlogan}>
                        {t(isHosTheme ? 'rooms_page_promo_hos_slogan' : 'rooms_page_promo_slogan')
                            .split(' ')
                            .map((word) => (
                                <span key={word} css={styles.promoSloganWord}>
                                    {word}
                                </span>
                            ))}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
